import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const denmarkFields = {
  dkCpr: taxIdFieldConfig("DK", "dkCpr"),
  dkConfirmCpr: confirmTaxIdFieldConfig("DK", "dkCpr"),
};
